import React from "react";
import HtmlRenderer from '../HtmlRenderer/HtmlRenderer';
import Code from '../../Code/Code';

import './BlogRenderer.css';

const BlogRenderer = ({ blogContent }) => {
    return (
        <div>
            {blogContent.map((item, index) => {
                if (item.h2) {
                    return <h1 className="n-color-purple" key={index}>{item.h2}</h1>;
                } else if (item.paragraph) {
                    return <HtmlRenderer key={index} html={item.paragraph} />;
                } else if (item.code) {
                    return  <Code codeSnippet={item.code} key={index}/>;
                } else {
                    return null; 
                }
            })}
        </div>
    );
}


export default BlogRenderer;